<template>
  <div class="content">
    <div class="content-body table-wrapper">
      <Table :loading="loading" highlight-row :data="changeLogs" :columns="columns" stripe border>
        <template slot-scope="{ row, column, index }" slot="auditPropsCell">
          <div class="origin-value">{{ getAuditLogDisplay(_.get(row, 'old_values.' + column.key), column.key) }}</div>
          <div class="new-value">{{ getAuditLogDisplay(_.get(row, 'new_values.' + column.key), column.key) }}</div>
        </template>
        <template slot-scope="{ row, column, index }" slot="propsCell">
          {{ _.get(row, column.key) }}
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import FieldsDef from './data/part-change-log-fields'
import XEUtils from 'xe-utils'
export default {
  name: 'PartAuditChangeLog',
  props: {
    id: {
      required: false
    },
    componentType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      changeLogs: [],
      categories: {},
      displayValues: {
        reviewed: {
          1: 'Reviewed',
          0: 'Draft',
          '-1': 'Invalid'
        }
      }
    }
  },
  computed: {
    columns: function () {
      return FieldsDef[this.componentType.replace('-', '_')]
    }
  },
  mounted () {
    if (this.id && this.componentType) {
      this.loadChangeLog(this.componentType, this.id)
    }
  },
  methods: {
    ...mapActions([
      'getManufacturerPartChangeLog',
      'getPartCategory'
    ]),
    loadChangeLog(type, id) {
      this.loading = true
      this.getManufacturerPartChangeLog({ component_type: type, id: id }).then((res) => {
        this.changeLogs = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    getAuditLogDisplay(value, property) {
      switch (property) {
        case 'part_category_id':
          if (value) {
            this.getPartCategoryDisplayValue(value)
            return this.categories[value] ? this.categories[value].chinese_name + ' (' + this.categories[value].name + ')' : value
          } else {
            return value
          }
        default:
          return _.get(this.displayValues, property + '.' + value, value)
      }
    },
    async getPartCategoryDisplayValue(id) {
      if (!this.categories[id] && XEUtils.includes(this.$store.state.part.partCategoriesIds, id)) {
        let partCategory = await this.getPartCategory(id).then(res => {
          return res
        })
        this.$set(this.categories, id, partCategory)
      }
      return this.categories[id]?.name
    }
  }
}
</script>

<style lang="less" scoped>
  .origin-value {
    color: gray;
    text-decoration: line-through
  }
  .new-value {
    color: green;
  }
</style>
